import { render, staticRenderFns } from "./LiabilitiesOtherYN.vue?vue&type=template&id=2de39b5a"
import script from "./LiabilitiesOtherYN.vue?vue&type=script&lang=js"
export * from "./LiabilitiesOtherYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports